<template>
    <ul class="recommendations-list">
        <li v-for="recommendation in props.recommendations" :key="`recommendation--${recommendation.id}`" class="recommendations-list__item">
            <RecommendationItem :is-edit-mode="false" :is-sample="false" :model-value="recommendation" />
        </li>
    </ul>
</template>
<script setup lang="ts">
    import type {Recommendation} from '~/types/domain/Recommendations';
    import RecommendationItem from '../RecommendationItem.vue';

    const props = defineProps<{
        recommendations: Recommendation[];
    }>();
</script>
